import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TUser, TUserBodyRequest, TUserResponse, adaptUserFromResponse, adaptUserToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_USERS } from '../../backend-paths';


export const userCreateApi = createAsyncThunk(
	`POST/${BACKEND_ADMIN_USERS}`,
	(payload: TUserBodyRequest, thunkApi) => {
		const dataRequest = adaptUserToRequest(payload);

		return HttpService.post<TUserResponse>(BACKEND_ADMIN_USERS, dataRequest).then(result => {
			return adaptUserFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TUser> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userCreateSlice = createSlice({
	name: 'userCreateSlice',
	initialState,
	reducers: {
		clearUserCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[userCreateApi.fulfilled.type]: (state, action: PayloadAction<TUser>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useUserCreateSelector = () => useAppSelector(state => state[userCreateSlice.name]);

export const { clearUserCreate } = userCreateSlice.actions;
